import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import { SelectImageData } from "../../../utils/common";
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data, IMG_URL } = useContext(Context);
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    watch,
    getValues,
  } = useForm({
    defaultValues: {
      quantitys: [
        {
          product_id: "",
          variant_id: "",
          quantity: "",
          landing_price: 0,
        },
      ],
    },
  });
  const [product, setProduct] = useState([]);
  const [productVariant, setProductVariant] = useState([]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetAllProduct = async () => {
    const response = await getData(
      `/common/masters/supplier-product?supplier_id=${watch("supplier_id")?.value || ""}`,
    );

    if (response?.success) {
      setProduct(await Select2Data(response?.data, "product_id"));
    }
  };
  const GetAllProductVariant = async (id) => {
    const response = await getData(`/common/masters/product-varient/${id}`);

    if (response?.success) {
      const result = response?.data?.map((data) => ({
        value: data?.id,
        label: `${data?.Metal?.name || ""} ${data?.Product?.Unit?.name || ""}`,
        name: "variant_id",
      }));
      setProductVariant(result);
    }
  };

  useEffect(() => {
    GetAllProduct();
  }, [watch("supplier_id")]);

  const watchQuantitys = watch("quantitys"); // watches the entire array

  const [CancellationPolicyError, setCancellationPolicyError] = useState("");
  useEffect(() => {
    register("quantitys", {
      validate: (value) => {
        const isValid = value && value.length > 0;
        setCancellationPolicyError(
          isValid ? "" : "At least one Purchase Quantity is required",
        );
        return isValid;
      },
    });
  }, [register]);
  const totalQuantity =
    watchQuantitys?.reduce((sum, item) => {
      const qty = parseFloat(item?.quantity);
      return sum + (isNaN(qty) ? 0 : qty);
    }, 0) || 0;

  const [submitLoading, setSubmitLoading] = useState(false);

  const onSubmit = async (data) => {
    try {
      setSubmitLoading(true);
      const DataToSend = new FormData();
      DataToSend.append("total_quantity", totalQuantity);
      if (data?.remark) {
        DataToSend.append("remark", data?.remark);
      }
      DataToSend.append("supplier_id", data?.supplier_id?.value);
      const variants = [];
      data.quantitys.forEach((val, index) => {
        variants.push({
          product_id: val?.product_id?.value,
          variant_id: val?.variant_id?.value,
          quantity: val.quantity,
          landing_price: val.landing_price,
        });
      });

      DataToSend.append("quantitys", JSON.stringify(variants));

      const response = await postData(
        `/admin/purchase-order/purchase-product`,
        DataToSend,
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const { fields, append, remove } = useFieldArray({
    control,
    name: "quantitys",
  });

  const [supplier, setSupplier] = useState([]);
  const GetAllSupplier = async (name = "") => {
    const response = await getData(
      `/common/masters/all-supplier?search=${name || ""}`,
    );
    if (response?.success) {
      setSupplier(await Select2Data(response?.data, "supplier_id"));
    }
  };
  useEffect(() => {
    GetAllSupplier();
  }, []);

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Purchase Order
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={() => handleSubmit(onSubmit)}
            role="form"
            // className="stateclass"
          >
            <Row>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>
                      Supplier{" "}
                      <p
                        style={{
                          fontSize: "12px",
                          color: "#808080",
                          marginTop: "4px",
                          marginBottom: "0px",
                        }}
                      >
                        Search by supplier or product name
                      </p>
                    </Form.Label>

                    <Controller
                      name="supplier_id"
                      {...register("supplier_id", {
                        required: "Select Supplier",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.supplier_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          {...field}
                          options={supplier}
                          filterOption={null}
                          onInputChange={(value, { action }) => {
                            if (action === "input-change") {
                              GetAllSupplier(value);
                            }
                          }}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption);
                            GetAllSupplier("");
                          }}
                        />
                      )}
                    />

                    {errors.supplier_id && (
                      <span className="text-danger">
                        {errors.supplier_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>
              <div className="oder-detail-holder mb-3">
                <div className="heading-holder">
                  <h6> Purchase Quantity</h6>
                </div>

                <div className="package-details-section">
                  {fields.map((variant, index) => (
                    <div key={variant.id} className="main-form-section mt-3">
                      <Row>
                        <Col md={6}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Product</Form.Label>
                              <Form.Group>
                                <Controller
                                  name={`quantitys.${index}.product_id`}
                                  control={control}
                                  rules={{
                                    required: "Select Product",
                                  }}
                                  render={({ field }) => (
                                    <Select
                                      styles={{
                                        control: (baseStyles) => ({
                                          ...baseStyles,
                                          borderColor: errors?.quantitys?.[
                                            index
                                          ]?.product_id
                                            ? "red"
                                            : baseStyles.borderColor,
                                        }),
                                      }}
                                      {...field}
                                      options={product}
                                      // value={product}
                                      onChange={(e) => {
                                        field.onChange(e?.value);
                                        setValue(
                                          `quantitys.${index}.product_id`,
                                          e,
                                        );
                                        setValue(
                                          `quantitys.${index}.variant_id`,
                                          "",
                                        );
                                        GetAllProductVariant(e?.value);
                                      }}
                                    />
                                  )}
                                />

                                {errors?.quantitys?.[index]?.product_id && (
                                  <span className="text-danger">
                                    {
                                      errors?.quantitys?.[index]?.product_id
                                        ?.message
                                    }
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Product Variant</Form.Label>
                              <Form.Group>
                                <Controller
                                  name={`quantitys.${index}.variant_id`} // name of the field
                                  {...register(
                                    `quantitys.${index}.variant_id`,
                                    {
                                      required: "Select Product Variant",
                                    },
                                  )}
                                  control={control}
                                  render={({ field }) => (
                                    <Select
                                      styles={{
                                        control: (baseStyles) => ({
                                          ...baseStyles,
                                          borderColor: errors?.variant_id?.[
                                            index
                                          ]?.product_id
                                            ? "red"
                                            : baseStyles,
                                        }),
                                      }}
                                      {...field}
                                      options={productVariant}
                                    />
                                  )}
                                />
                                {errors?.quantitys?.[index]?.variant_id && (
                                  <span className="text-danger">
                                    {errors.quantitys[index].variant_id.message}
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Quantity</Form.Label>

                              <Form.Group>
                                <Form.Control
                                  type="text"
                                  name={`quantitys.${index}.quantity`}
                                  placeholder="Quantity"
                                  inputMode="decimal"
                                  className={classNames("", {
                                    "is-invalid":
                                      errors?.quantitys?.[index]?.quantity,
                                  })}
                                  {...register(`quantitys.${index}.quantity`, {
                                    required: "Quantity is required",
                                    validate: (value) => {
                                      if (!/^\d+(\.\d+)?$/.test(value)) {
                                        return "Please enter a valid quantity";
                                      }

                                      if (Number(value) <= 0) {
                                        return "Quantity must be greater than 0";
                                      }

                                      return true;
                                    },
                                  })}
                                  onKeyDown={(e) => {
                                    // Allow control/navigation keys
                                    if (
                                      e.key === "Backspace" ||
                                      e.key === "Delete" ||
                                      e.key === "ArrowLeft" ||
                                      e.key === "ArrowRight" ||
                                      e.key === "Tab"
                                    ) {
                                      return;
                                    }

                                    // Allow only numbers and decimal
                                    if (!/[\d.]/.test(e.key)) {
                                      e.preventDefault();
                                    }

                                    // Only one decimal point
                                    if (
                                      e.key === "." &&
                                      e.currentTarget.value.includes(".")
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                />

                                {errors?.quantitys?.[index]?.quantity && (
                                  <span className="text-danger">
                                    {errors.quantitys[index].quantity.message}
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Price</Form.Label>

                              <Form.Group>
                                <Form.Control
                                  type="text"
                                  name={`quantitys.${index}.landing_price`}
                                  placeholder="Price"
                                  inputMode="decimal"
                                  className={classNames("", {
                                    "is-invalid":
                                      errors?.quantitys?.[index]?.landing_price,
                                  })}
                                  {...register(
                                    `quantitys.${index}.landing_price`,
                                    {
                                      required: "Price is required",
                                      validate: (value) => {
                                        if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                                          return "Please enter a valid price";
                                        }

                                        if (Number(value) <= 0) {
                                          return "Price must be greater than 0";
                                        }

                                        return true;
                                      },
                                    },
                                  )}
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "Backspace" ||
                                      e.key === "Delete" ||
                                      e.key === "ArrowLeft" ||
                                      e.key === "ArrowRight" ||
                                      e.key === "Tab"
                                    ) {
                                      return;
                                    }

                                    if (!/[\d.]/.test(e.key)) {
                                      e.preventDefault();
                                    }

                                    if (
                                      e.key === "." &&
                                      e.currentTarget.value.includes(".")
                                    ) {
                                      e.preventDefault();
                                    }

                                    // Maximum 2 decimal places
                                    const value = e.currentTarget.value;
                                    const decimalIndex = value.indexOf(".");

                                    if (
                                      decimalIndex !== -1 &&
                                      e.key !== "." &&
                                      value.substring(decimalIndex + 1)
                                        .length >= 2 &&
                                      e.currentTarget.selectionStart >
                                        decimalIndex
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                />

                                {errors?.quantitys?.[index]?.landing_price && (
                                  <span className="text-danger">
                                    {
                                      errors.quantitys[index].landing_price
                                        .message
                                    }
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                      {fields.length > 1 && (
                        <button
                          className="mt-3 add-varient"
                          type="button"
                          onClick={() => remove(index)} // Remove the variant
                        >
                          Remove Product
                        </button>
                      )}
                      <hr />
                    </div>
                  ))}
                  {CancellationPolicyError && (
                    <div className="text-danger">{CancellationPolicyError}</div>
                  )}
                  <div>Total Quantity:{totalQuantity}</div>
                </div>
                <hr />
                <div className="text-center">
                  <button
                    type="button"
                    className="add-varient"
                    onClick={() => append({})}
                  >
                    + Add Product
                  </button>
                </div>
              </div>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>remark</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          name="remark"
                          placeholder="remark"
                          className={classNames("", {
                            "is-invalid": errors?.remark,
                          })}
                          {...register("remark", {
                            validate: (value) => {
                              if (!value?.trim()) {
                                return true;
                              }

                              return (
                                value.length <= 200 ||
                                "Data must be 200 characters or less"
                              );
                            },
                          })}
                        />
                      </InputGroup>
                      {errors.remark && (
                        <span className="text-danger">
                          {errors.remark.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    loading={submitLoading}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
